import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

import reportWebVitals from './reportWebVitals';
import './Assets/Styles/Main.scss'
import {FaWhatsapp} from "react-icons/fa6";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <App/>

            <a href="https://wa.me/+16474903646"  target="_blank" title="Message To Whatsapp"
               className=" back-to-top whatsapp-float d-flex align-items-center justify-content-center bg-success text-decoration-none " rel="noreferrer">
<FaWhatsapp className='icon' />
            </a>


    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
